import type { Project } from './types';

export const DEMO_PROJECTS: Record<string, Project> = {
  utopia: {
    id: 'utopia',
    name: 'Cornerstone Utopia',
    builder: 'Brigade Group',
    location: 'Hebbal · ORR',
    price: '₹68–74L',
    bhk: '2 BHK',
    sqft: '1,120–1,180 sqft',
    fit: 'Strong layout · mid-budget premium',
    fitTone: 'success',
    tag: 'Model flat ready',
    accent: '#3d4a6a',
    possession: 'Sep 2027',
    commute: '~20 min to Manyata',
  },
  ayana: {
    id: 'ayana',
    name: 'Ayana',
    builder: 'Lokations',
    location: 'Whitefield',
    price: '₹58–62L',
    bhk: '2 BHK',
    sqft: '1,050–1,120 sqft',
    fit: 'Within budget',
    fitTone: 'success',
    tag: 'Best fit',
    accent: '#2d5a47',
    possession: 'Dec 2027',
    commute: '~25 min to ORR',
  },
  buena: {
    id: 'buena',
    name: 'Buena Vista',
    builder: 'Brigade Group',
    location: 'Whitefield',
    price: '₹72–78L',
    bhk: '2 BHK',
    sqft: '1,180–1,240 sqft',
    fit: 'Stretch · premium micro-market',
    fitTone: 'stretch',
    tag: 'Location',
    accent: '#5c4d3a',
    possession: 'Jun 2027',
    commute: '~25 min to ORR',
  },
  krishnaja: {
    id: 'krishnaja',
    name: 'Krishnaja Greens',
    builder: 'Lokations',
    location: 'Sarjapur',
    price: '₹46–52L',
    bhk: '2 BHK',
    sqft: '980–1,050 sqft',
    fit: 'Best value · slightly farther',
    fitTone: 'success',
    tag: 'Entry price',
    accent: '#3d5a6a',
    possession: 'Mar 2028',
    commute: '~40 min to ORR',
  },
};

export const CONCIERGE_TIERS = [
  {
    id: 'free',
    title: 'Advisor',
    price: 'Included',
    description: 'Shortlist, compare, and plan multi-site days. Anonymous until you choose to reveal.',
    featured: false,
  },
  {
    id: 'visit',
    title: 'Visit day',
    price: '₹3,500',
    description: 'Cab between sites, scheduling, and on-day coordination.',
    featured: true,
  },
  {
    id: 'negotiation',
    title: 'Negotiation',
    price: 'From ₹35,000',
    description: 'Floor-rise, flexi-pay, and counter-offers handled on your behalf.',
    featured: false,
  },
  {
    id: 'full',
    title: 'Full concierge',
    price: 'From ₹75,000',
    description: 'Search through booking — loan coordination, legal Q&A, advocacy.',
    featured: false,
  },
];
